__webpack_require__.p = "/resources/tools/ai-page-builder/";